import React from 'react';

export function UtilityBar() {
  const [now, setNow] = React.useState(() => new Date());
  React.useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const t = now.toUTCString().slice(17, 25);
  return (
    <div className="util">
      <span className="live">SYSTEMS NOMINAL</span>
      <span className="sep">·</span>
      <span>FINMARS / ASSET-SELECTOR · v0.9.4-rc3</span>
      <span className="sep">·</span>
      <span>FMP · SEC · 8 data lanes</span>
      <span className="right">
        <a href="https://github.com/finmars-platform/finmars-core" target="_blank" rel="noopener">GITHUB ↗</a>
        <span className="sep">·</span>
        <span>UTC {t}</span>
        <span className="sep">·</span>
        <span>BUILD 26.05.18</span>
      </span>
    </div>
  );
}

export function Nav() {
  return (
    <nav className="nav">
      <a href="#" className="brand">
        <img className="brand-logo" src="https://finmars.com/wp-content/uploads/2025/06/Logo-icon-1.png" alt="Finmars" />
        <span className="brand-wm">
          <span className="brand-fm">Finmars</span>
          <span className="brand-prod">Asset Selector</span>
        </span>
      </a>
      <div className="nav-links">
        <a href="#product">Product</a>
        <a href="#how">How it works</a>
        <a href="#methodology">Methodology</a>
        <a href="https://finmars.com" target="_blank" rel="noopener">Finmars ↗</a>
      </div>
      <div className="nav-cta">
        <a href="#cta" className="btn btn-dark">Sign in</a>
        <a href="#cta" className="btn btn-primary">Request access</a>
      </div>
    </nav>
  );
}

export function Hero() {
  return (
    <section className="hero">
      <div className="hero-grid">
        <div>
          <div className="kicker"><span className="dot">●</span>SECTOR SCANS FOR EQUITY ANALYSTS</div>
          <h1>
            Scan a sector.<br/>
            Surface the <em>ten</em> ideas<br/>
            worth your time.
          </h1>
          <p className="hero-sub">
            <strong>Asset Selector</strong> screens an entire industry in one pass —
            automatic DCF, peer multiples, and a transparent rating on every ticker —
            so analysts can shortlist the candidates that deserve a full thesis.
            Built for analysts. <span className="hl">Not</span> for robots.
          </p>

          <div className="hero-cta">
            <a href="#cta" className="btn btn-primary btn-arrow">Start free trial</a>
            <a href="#coverage" className="btn">See live demo</a>
          </div>

          <div className="hero-meta">
            <div>
              <div className="num">5<span className="unit">×</span></div>
              <div className="lbl">Your present coverage</div>
            </div>
            <div>
              <div className="num">50<span className="unit"> → 10</span></div>
              <div className="lbl">Tickers · shortlist</div>
            </div>
            <div>
              <div className="num">14<span className="unit">/co.</span></div>
              <div className="lbl">Indicators scored</div>
            </div>
            <div>
              <div className="num">100<span className="unit">%</span></div>
              <div className="lbl">Human-in-the-loop</div>
            </div>
          </div>
        </div>

        <div className="term-card">
          <div className="term-head">
            <span className="dots"><span /><span /><span /></span>
            <span>asset-selector / session.tty</span>
            <span style={{marginLeft:'auto'}}>READY</span>
          </div>
          <div className="term-body">
            <div className="ln"><span className="ix">01</span><span><span className="prompt">›</span><span className="com">// scan a 50-name sector for the next 10 ideas</span></span></div>
            <div className="ln"><span className="ix">02</span><span><span className="prompt">›</span>universe <span className="key">=</span> <span className="str">"US.HIGH_TECH"</span>  <span className="com">// 50 tickers</span></span></div>
            <div className="ln"><span className="ix">03</span><span><span className="prompt">›</span>peers <span className="key">=</span> scan(universe)</span></div>
            <div className="ln"><span className="ix">04</span><span className="faint">→ 50 companies · 14 indicators · 4m ago</span></div>
            <div className="ln"><span className="ix">05</span><span><span className="prompt">›</span>dcf <span className="key">=</span> auto.dcf(peers)</span></div>
            <div className="ln"><span className="ix">06</span><span className="faint">→ FCFE / FCFF upside computed for 50 / 50</span></div>
            <div className="ln"><span className="ix">07</span><span><span className="prompt">›</span>shortlist <span className="key">=</span> rank(peers, top<span className="key">=</span>10)</span></div>
            <div className="ln"><span className="ix">08</span><span className="faint">→ NVDA 124.50 · AVGO 115.30 · PLTR 112.00 · MSFT …</span></div>
            <div className="ln"><span className="ix">09</span><span><span className="prompt">›</span>investigate(shortlist)<span className="cursor"></span></span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Manifesto() {
  return (
    <section className="manifesto">
      <p className="quote">
        AI should not replace a human in finance, or generate investment
        recommendations on its own. <b>We do not believe in human-independent</b>
        robotic trading. We believe in analysts who cover five times more — without
        sacrificing depth.
      </p>
      <div className="attrib">— Founding principle · Finmars / Asset Selector</div>
    </section>
  );
}

export function BringYourOwnTemplate() {
  return (
    <section className="section byo-section" id="enterprise">
      <div className="section-num">03 — YOUR MODEL, OUR DATA</div>
      <div className="section-head">
        <h2>Upload <em>your</em> DCF template. We populate it.</h2>
        <p>Every firm has a house model. Ours is just an example. Upload your XLS template once — Asset Selector maps and auto-populates every cell from structured filings, on demand, for every ticker in the universe.</p>
      </div>

      <div className="byo-grid">
        <div className="byo-copy">
          <div className="byo-points">
            <div className="byo-pt">
              <div className="byo-pt-num">01</div>
              <div className="byo-pt-body">
                <h4>Drop in your template</h4>
                <p>Upload <code>your-house-dcf.xlsx</code>. The system parses the sheet structure, finds the input cells, and reads your labels — without you reformatting anything.</p>
              </div>
            </div>
            <div className="byo-pt">
              <div className="byo-pt-num">02</div>
              <div className="byo-pt-body">
                <h4>Map fields once</h4>
                <p>Tag which cells consume which inputs — Revenue 2024, EBITDA Margin, Net Debt, WACC. Save it as your firm's template. Done — every analyst on the desk inherits the mapping.</p>
              </div>
            </div>
            <div className="byo-pt">
              <div className="byo-pt-num">03</div>
              <div className="byo-pt-body">
                <h4>Run for any ticker</h4>
                <p>Open any company. Asset Selector populates your template from filings + FMP + your own data sources. Open in Excel via Azure — fully live, fully editable, with your own formatting.</p>
              </div>
            </div>
          </div>

          <div className="byo-flags">
            <span className="byo-flag">YOUR FORMULAS</span>
            <span className="byo-flag">YOUR ASSUMPTIONS</span>
            <span className="byo-flag">YOUR FORMATTING</span>
            <span className="byo-flag byo-flag-accent">OUR AUTOMATION</span>
          </div>
        </div>

        <div className="xls-mock">
          <div className="xls-bar">
            <span className="xls-traffic"><span></span><span></span><span></span></span>
            <span className="xls-file">house-dcf-template.xlsx</span>
            <span className="xls-meta">YOUR TEMPLATE · POPULATED FROM FINMARS</span>
          </div>
          <div className="xls-toolbar">
            <span>File</span><span>Home</span><span>Insert</span><span>Formulas</span><span>Data</span><span>Review</span>
            <span className="xls-tool-spacer"></span>
            <span className="xls-binding">● LIVE · BOUND TO ASSET SELECTOR</span>
          </div>
          <div className="xls-grid">
            <div className="xls-row xls-row-h">
              <div className="xls-cell xls-corner"></div>
              <div className="xls-cell xls-col">A</div>
              <div className="xls-cell xls-col">B</div>
              <div className="xls-cell xls-col">C</div>
              <div className="xls-cell xls-col">D</div>
              <div className="xls-cell xls-col">E</div>
            </div>
            {[
              {n:'1',  a:'DCF — NVIDIA Corporation',   b:'',          c:'',         d:'',         e:'',         bold:true, color:true},
              {n:'2',  a:'',                            b:'2024A',     c:'2025E',    d:'2026E',    e:'2027E',    header:true},
              {n:'3',  a:'Revenue',                     b:'60 922',    c:'108 451',  d:'168 240',  e:'212 770',  filled:true},
              {n:'4',  a:'  growth %',                  b:'',          c:'78.0%',    d:'55.1%',    e:'26.5%',    derived:true},
              {n:'5',  a:'EBITDA',                      b:'34 124',    c:'72 663',   d:'117 768',  e:'149 970',  filled:true},
              {n:'6',  a:'  margin %',                  b:'56.0%',     c:'67.0%',    d:'70.0%',    e:'70.5%',    derived:true},
              {n:'7',  a:'Capex',                       b:'(1 069)',   c:'(3 850)',  d:'(5 800)',  e:'(7 200)',  filled:true},
              {n:'8',  a:'Δ Working capital',           b:'(2 480)',   c:'(4 100)',  d:'(5 350)',  e:'(6 420)',  filled:true},
              {n:'9',  a:'WACC',                        b:'',          c:'9.80%',    d:'',         e:'',         input:true},
              {n:'10', a:'Terminal growth',             b:'',          c:'3.00%',    d:'',         e:'',         input:true},
            ].map(r => (
              <div className={`xls-row ${r.header?'xls-row-th':''}`} key={r.n}>
                <div className="xls-cell xls-rowh">{r.n}</div>
                <div className={`xls-cell xls-label ${r.bold?'xls-bold':''} ${r.color?'xls-accent':''}`}>{r.a}</div>
                {[r.b, r.c, r.d, r.e].map((v, i) => (
                  <div key={i} className={`xls-cell xls-val ${r.filled?'xls-filled':''} ${r.derived?'xls-derived':''} ${r.input?'xls-input':''}`}>
                    {v}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="xls-legend">
            <span><span className="xls-lg-sw xls-lg-filled"></span> Auto-populated from filings</span>
            <span><span className="xls-lg-sw xls-lg-input"></span> Your override</span>
            <span><span className="xls-lg-sw xls-lg-derived"></span> Your formula</span>
          </div>
          <div className="xls-tabs">
            <span className="xls-tab xls-tab-on">Inputs</span>
            <span className="xls-tab">Assumptions</span>
            <span className="xls-tab">DCF</span>
            <span className="xls-tab">Sensitivities</span>
            <span className="xls-tab">Output</span>
            <span className="xls-tab xls-tab-add">+</span>
          </div>
        </div>
      </div>
    </section>
  );
}

const STEPS = [
  { ix:'01', title:'Pick a sector or upload a peer set',
    desc:'Choose from curated sectors, or paste tickers. The system fetches structured filings, earnings, and FMP data in seconds.',
    pill:'INGEST' },
  { ix:'02', title:'Auto-build a starter DCF',
    desc:'A standard DCF is generated for every peer as a working example — revenue projections, margins, WACC, terminal — all derived from filings. It is a starting point, not the final word.',
    pill:'BUILD' },
  { ix:'03', title:'Rate against the peer set',
    desc:'14 default indicators score every company. Customize weights, swap multiples, define your own — no code required.',
    pill:'RATE' },
  { ix:'04', title:'Open in Excel — yours or ours',
    desc:'Use our starter DCF, or upload your firm\u2019s own XLS template — the system populates it automatically from structured financial data. Edit in Excel with live data bindings either way.',
    pill:'EXCEL' },
  { ix:'05', title:'Hand off to the committee',
    desc:'Every number is sourced. Every assumption is editable. The analyst signs off — not the model.',
    pill:'SHIP' },
];

export function HowItWorks() {
  return (
    <section className="section" id="how">
      <div className="section-num">02 — PROCESS</div>
      <div className="section-head">
        <h2>From ticker to defensible <em>DCF</em>, in under five steps.</h2>
        <p>Asset Selector is opinionated about workflow. Each step is auditable, every assumption traces back to a filing or an analyst override.</p>
      </div>
      <div className="steps">
        {STEPS.map(s => (
          <div className="step" key={s.ix}>
            <div className="ix">STEP <b>{s.ix}</b></div>
            <div className="ttl">{s.title}</div>
            <div className="dsc">{s.desc}</div>
            <div className="glyph"><span className="pill">{s.pill}</span> ← auto · ↦ human</div>
          </div>
        ))}
      </div>
    </section>
  );
}

const FEATURES = [
  { id:'F-01', title:'Peer Comparison',
    desc:'A single screen to compare an entire sector across valuation multiples, financial indicators and custom metrics.',
    meta:'TABLE · SORT · FILTER',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="2" y="6" width="28" height="20" /><line x1="2" y1="12" x2="30" y2="12"/><line x1="11" y1="6" x2="11" y2="26"/><line x1="21" y1="6" x2="21" y2="26"/>
      </svg>
    )
  },
  { id:'F-02', title:'Company Q&A',
    desc:'Instant answers on market position, financials, risks and recent news — sourced from SEC filings and earnings calls.',
    meta:'CITED · RETRIEVAL · SEC',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M5 7h22v15H14l-6 5v-5H5z"/><line x1="10" y1="12" x2="22" y2="12"/><line x1="10" y1="17" x2="18" y2="17"/>
      </svg>
    )
  },
  { id:'F-03', title:'DCF via Azure / Office',
    desc:'A starter DCF model — built for you as a sensible example, not as the final say. Open or download directly to Excel via Azure integration and edit with live data bindings.',
    meta:'.XLSX · LIVE BINDING · EXAMPLE',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="4" y="4" width="24" height="24" /><line x1="4" y1="11" x2="28" y2="11"/><line x1="4" y1="18" x2="28" y2="18"/><line x1="12" y1="4" x2="12" y2="28"/><line x1="20" y1="4" x2="20" y2="28"/>
      </svg>
    )
  },
  { id:'F-04', title:'News Browser',
    desc:'Browse recent news with category filters — earnings, M&A, regulation, macro — all linked to the relevant company.',
    meta:'REALTIME · TAGGED',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="3" y="5" width="22" height="22"/><line x1="3" y1="11" x2="25" y2="11"/><line x1="7" y1="16" x2="21" y2="16"/><line x1="7" y1="20" x2="21" y2="20"/><line x1="7" y1="24" x2="17" y2="24"/>
      </svg>
    )
  },
  { id:'F-05', title:'Bring your own DCF template',
    desc:'Upload your firm\u2019s XLS DCF template — the system populates every cell automatically from structured filings. Your house model, our automation. The starter DCF is just an example.',
    meta:'YOUR XLS · AUTO-POPULATED',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M6 4h14l6 6v18H6z"/><path d="M20 4v6h6"/><path d="M16 20v-7m0 0-4 4m4-4 4 4"/>
      </svg>
    )
  },
  { id:'F-06', title:'Processed Companies',
    desc:'See the full list with rating components and multiples at a glance. Sort, filter, and rank instantly.',
    meta:'LIST · RANK · EXPORT',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <line x1="8" y1="9" x2="28" y2="9"/><line x1="8" y1="16" x2="28" y2="16"/><line x1="8" y1="23" x2="28" y2="23"/><circle cx="4" cy="9" r="1.4" fill="currentColor"/><circle cx="4" cy="16" r="1.4" fill="currentColor"/><circle cx="4" cy="23" r="1.4" fill="currentColor"/>
      </svg>
    )
  },
  { id:'F-07', title:'Company Deep-Dive',
    desc:'Click any ticker to access the full description, AI-generated report, news feed and the underlying DCF model.',
    meta:'REPORT · FILINGS · MODEL',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <circle cx="14" cy="14" r="9"/><line x1="21" y1="21" x2="28" y2="28"/>
      </svg>
    )
  },
  { id:'F-08', title:'Bring your own indicators',
    desc:'Create or modify indicators and multiples in a no-code editor to match your investment style. Tag any column into the rating — your indicators drive your score. Defaults are starting points, not gospel.',
    meta:'NO-CODE · YOUR RATING',
    glyph:(
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4">
        <line x1="6" y1="6" x2="6" y2="26"/><line x1="16" y1="6" x2="16" y2="26"/><line x1="26" y1="6" x2="26" y2="26"/>
        <circle cx="6" cy="11" r="2.4" fill="var(--bg)"/><circle cx="16" cy="20" r="2.4" fill="var(--bg)"/><circle cx="26" cy="14" r="2.4" fill="var(--bg)"/>
      </svg>
    )
  },
];

export function Features() {
  return (
    <section className="section" id="product">
      <div className="section-num">03 — CAPABILITIES</div>
      <div className="section-head">
        <h2>Everything the analyst needs. <em>Nothing</em> they don't.</h2>
        <p>Asset Selector is a workbench — peer screens, AI Q&A, automated DCFs, and an Excel handoff. The committee still owns the recommendation.</p>
      </div>
      <div className="feat-grid">
        {FEATURES.map(f => (
          <div className="feat" key={f.id}>
            <div className="feat-head"><span className="id">{f.id}</span> · CAPABILITY</div>
            <div className="glyph" style={{color:'var(--accent)', marginTop:18}}>{f.glyph}</div>
            <h4>{f.title}</h4>
            <p>{f.desc}</p>
            <div className="meta-line">{f.meta}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

const INDICATORS = [
  { id:'R.01', nm:'EBITDA Margin · past',    desc:'Trailing operating profitability vs. sector mean.' },
  { id:'R.02', nm:'EBITDA Margin · forward', desc:'Projected operating profitability vs. sector mean.' },
  { id:'R.03', nm:'Sales CAGR · past',       desc:'Realized 2-year revenue growth vs. sector mean.' },
  { id:'R.04', nm:'Sales CAGR · forward',    desc:'Consensus 2-year revenue trajectory vs. sector mean.' },
  { id:'R.05', nm:'Quick Ratio',             desc:'Short-term liquidity and balance-sheet strength.' },
];

export function Methodology() {
  return (
    <section className="section" id="methodology">
      <div className="section-num">04 — METHODOLOGY</div>
      <div className="section-head">
        <h2>How we <em>rate</em>. A transparent three-step normalization, indicator-by-indicator.</h2>
        <p>Analysts pick which indicators participate by tagging columns into a Rating group. Only tagged indicators count. Nothing is hidden — every score traces back to the same three steps.</p>
      </div>
      <div className="method">
        <div className="method-side">
          <h3>Your indicators. Your rating. <span className="hl">Not ours.</span></h3>
          <p>The defaults below are sensible starting points — nothing more. Tag, untag, replace, or build new indicators in the no-code editor and they slot straight into the rating. The math is the same; the inputs are yours.</p>
          <div className="byo-callout">
            <div className="byo-head">
              <span className="byo-tag">BYO</span>
              <span>Bring your own indicator</span>
            </div>
            <ul className="byo-list">
              <li><b>Define</b> any formula across financial line items — no code, no waiting on engineering.</li>
              <li><b>Tag</b> the new column into the Rating group and it's instantly part of the score.</li>
              <li><b>Share</b> it across the desk so the whole team rates the same way.</li>
            </ul>
          </div>
          <div className="formula">
            <div><span className="c">// Per-indicator score, for company c</span></div>
            <div><span className="k">avg</span>ᵢ <span className="key">=</span> <span className="v">mean</span>(indicatorᵢ across peers)<span className="c">    /* step 1 */</span></div>
            <div><span className="k">ratio</span>ᵢ(c) <span className="key">=</span> indicatorᵢ(c) <span className="key">/</span> <span className="k">avg</span>ᵢ<span className="c">          /* step 2 */</span></div>
            <div><span className="k">score</span>ᵢ(c) <span className="key">=</span> z(<span className="k">ratio</span>ᵢ(c)) <span className="key">×</span> <span className="v">100</span><span className="c">      /* step 3 */</span></div>
            <div style={{paddingTop:8}}><span className="c">// Final rating = simple mean across rated indicators</span></div>
            <div><span className="k">rating</span>(c) <span className="key">=</span> mean( <span className="k">score</span>ᵢ(c) <span className="k">for i in</span> rated )</div>
          </div>
        </div>
        <div className="indicators">
          <div className="ind-row method-head">
            <span className="id">RATING GROUP</span>
            <span className="nm">Currently rated indicators · defaults</span>
            <span className="wt">role</span>
            <span></span>
          </div>
          {INDICATORS.map(i => (
            <div className="ind-row" key={i.id}>
              <span className="id">{i.id}</span>
              <span className="nm">{i.nm}<span className="desc">{i.desc}</span></span>
              <span className="wt">equal</span>
              <span className="vis"><i style={{width:'100%'}} /></span>
            </div>
          ))}
          <div className="ind-row ind-row-byo">
            <span className="id">R.0n</span>
            <span className="nm">
              Your indicator <span className="hl">·</span> defined by you
              <span className="desc">e.g. "ROIC adjusted for operating leases", "Net cash / interest expense", "Capex intensity vs. 3-yr avg" — whatever your desk rates on.</span>
            </span>
            <span className="wt">equal</span>
            <span className="vis vis-byo"><i style={{width:'100%'}} /></span>
          </div>
          <div className="ind-row" style={{borderBottom:0, color:'var(--fg-dim)'}}>
            <span className="id" style={{color:'var(--accent)'}}>+</span>
            <span className="nm" style={{color:'var(--fg-dim)'}}>Tag any column → it joins the rating. Untag to remove. Build new indicators in the no-code editor — no engineering ticket required.</span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <div className="method-steps">
        <div className="ms-row">
          <div className="ms-step">
            <div className="ms-num">STEP 01</div>
            <div className="ms-ttl">Sector average</div>
            <div className="ms-dsc">For each rated indicator the system computes the mean across every company in the peer set. This is the baseline — visible in the "Avg" row at the top of the table.</div>
            <div className="ms-eq">avgᵢ <span className="k">=</span> mean(indicatorᵢ)</div>
          </div>
          <div className="ms-step">
            <div className="ms-num">STEP 02</div>
            <div className="ms-ttl">Raw ratio</div>
            <div className="ms-dsc">Each company's value is divided by the sector average. 1.00 means "exactly at sector"; 1.50 means "50% above"; 0.50 means "50% below". Easy to read, easy to defend.</div>
            <div className="ms-eq">ratioᵢ(c) <span className="k">=</span> indicatorᵢ(c) <span className="k">/</span> avgᵢ</div>
          </div>
          <div className="ms-step">
            <div className="ms-num">STEP 03</div>
            <div className="ms-ttl">Normalize · score</div>
            <div className="ms-dsc">Raw ratios live on different scales — some indicators cluster, others spread wildly. We z-score each ratio against the group mean, scale to a standard spread, and multiply by 100.</div>
            <div className="ms-eq">scoreᵢ(c) <span className="k">=</span> z(ratioᵢ) <span className="k">×</span> 100</div>
          </div>
        </div>
        <div className="ms-result">
          <div className="ms-result-bar">
            <div className="ms-result-line">
              <span className="ms-mark">0</span>
              <span className="ms-mark">50</span>
              <span className="ms-mark ms-mark-100">100<span className="ms-pin">▼ SECTOR AVERAGE</span></span>
              <span className="ms-mark">150</span>
              <span className="ms-mark">200</span>
            </div>
            <div className="ms-result-zones">
              <span className="ms-zone ms-under">UNDERPERFORMS</span>
              <span className="ms-zone ms-over">OUTPERFORMS</span>
            </div>
          </div>
          <div className="ms-result-note">
            Final rating <b>=</b> simple average of every per-indicator score. <span className="faint">·</span> 100% is sector parity. <span className="faint">·</span> Above 100% means the company beats its peers on the indicators <span className="hl">you</span> chose to rate.
          </div>
        </div>

        <div className="qc-block">
          <div className="qc-head">
            <span className="qc-tag">QUALITY GATE</span>
            <h3>FCFE Upside ≈ FCFF Upside. When upsides diverge, we flag it.</h3>
          </div>
          <div className="qc-grid">
            <div className="qc-copy">
              <p>Every auto-built DCF runs an internal consistency check on its valuation outputs: <b>FCFE Upside</b> and <b>FCFF Upside</b> should not disagree materially — both routes to fair value rest on the same underlying cash flows, only differing in how debt is treated.</p>
              <p>When the two upsides diverge, something upstream is off — usually a debt schedule, a minority-interest line, or a non-operating asset that didn't flow consistently into both paths. Asset Selector highlights those rows directly in the peer table, so an analyst sees the suspect company before signing off on the screen.</p>
            </div>
            <div className="qc-vis">
              <div className="qc-row qc-row-ok">
                <span className="qc-tk">NVDA</span>
                <div className="qc-bars">
                  <div className="qc-bar"><span className="qc-bar-lbl">FCFE↑</span><span className="qc-bar-val">+0.13</span><span className="qc-bar-fill" style={{width:'56%'}}></span></div>
                  <div className="qc-bar"><span className="qc-bar-lbl">FCFF↑</span><span className="qc-bar-val">+0.13</span><span className="qc-bar-fill" style={{width:'56%'}}></span></div>
                </div>
                <span className="qc-delta qc-ok">Δ 0.00 · OK</span>
              </div>
              <div className="qc-row qc-row-ok">
                <span className="qc-tk">MSFT</span>
                <div className="qc-bars">
                  <div className="qc-bar"><span className="qc-bar-lbl">FCFE↑</span><span className="qc-bar-val">+0.06</span><span className="qc-bar-fill" style={{width:'53%'}}></span></div>
                  <div className="qc-bar"><span className="qc-bar-lbl">FCFF↑</span><span className="qc-bar-val">+0.02</span><span className="qc-bar-fill" style={{width:'51%'}}></span></div>
                </div>
                <span className="qc-delta qc-ok">Δ 0.04 · OK</span>
              </div>
              <div className="qc-row qc-row-warn">
                <span className="qc-tk">ORCL</span>
                <div className="qc-bars">
                  <div className="qc-bar qc-bar-neg"><span className="qc-bar-lbl">FCFE↑</span><span className="qc-bar-val">−0.52</span><span className="qc-bar-fill" style={{width:'48%'}}></span></div>
                  <div className="qc-bar qc-bar-neg"><span className="qc-bar-lbl">FCFF↑</span><span className="qc-bar-val">−1.32</span><span className="qc-bar-fill" style={{width:'18%'}}></span></div>
                </div>
                <span className="qc-delta qc-warn">⚠ Δ 0.80 · INSPECT</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CTA() {
  return (
    <section className="cta" id="cta">
      <div className="cta-grid">
        <div>
          <div className="kicker"><span className="dot">●</span>REQUEST ACCESS · CLOSED BETA</div>
          <h2 style={{marginTop:18}}>
            Get a <em>seat</em> in the next analyst cohort.
          </h2>
          <p className="sub">
            We're rolling out access in waves. Get the onboarding pack, a sample
            peer screen, and a slot to talk with the team.
          </p>
        </div>
        <div>
          <div className="cta-actions">
            <a href="https://finmars.com/contact/" target="_blank" rel="noopener" className="btn btn-primary btn-arrow">Request access</a>
            <a href="mailto:hello@finmars.com" className="btn btn-dark">Write to us</a>
          </div>
          <div className="email-foot">
            <span className="ok">✓ Free trial</span> · no card · EU-hosted · Cancel anytime
          </div>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer>
      <div className="foot-grid">
        <div>
          <div className="foot-brand">
            <div className="foot-product">Asset Selector</div>
            <div className="foot-by">
              <span>a project of</span>
              <a href="https://finmars.com" target="_blank" rel="noopener" className="foot-fm">
                <img src="https://finmars.com/wp-content/uploads/2025/06/Logo-icon-1.png" alt="Finmars" />
                <span>Finmars</span>
              </a>
            </div>
          </div>
          <p style={{maxWidth:300, color:'var(--fg-dim)', marginTop:18}}>
            Built on the world's first open-source finance platform.
            Research automation for equity analysts and investment committees.
          </p>
          <div className="foot-socials">
            <a href="https://github.com/finmars-platform/finmars-core" target="_blank" rel="noopener">GitHub</a>
            <a href="https://www.linkedin.com/company/finmars/" target="_blank" rel="noopener">LinkedIn</a>
          </div>
        </div>
        <div>
          <h5>Product</h5>
          <ul>
            <li><a href="#product">Peer Comparison</a></li>
            <li><a href="#product">Company Q&A</a></li>
            <li><a href="#product">DCF Models</a></li>
            <li><a href="#product">Custom Indicators</a></li>
          </ul>
        </div>
        <div>
          <h5>Finmars</h5>
          <ul>
            <li><a href="https://finmars.com/about/" target="_blank" rel="noopener">About</a></li>
            <li><a href="https://finmars.com/blog/" target="_blank" rel="noopener">Blog</a></li>
            <li><a href="https://finmars.com/pricing/" target="_blank" rel="noopener">Pricing</a></li>
            <li><a href="https://finmars.com/marketplace/" target="_blank" rel="noopener">Marketplace</a></li>
          </ul>
        </div>
      </div>
      <div className="colofon">
        <div className="blob">
          <span>© 2026 Finmars SCSA · 9 Rue du Laboratoire, Luxembourg City</span>
          <span>·</span>
          <span>Not investment advice. Analysts own every recommendation.</span>
        </div>
        <div className="blob">
          <span>v0.9.4-rc3</span>
          <span>·</span>
          <span>UPTIME 99.98%</span>
        </div>
      </div>
    </footer>
  );
}
